import React, { useState } from 'react';
import Cookies from 'js-cookie';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar'
import Popover from '@mui/material/Popover';
import useScreenWidth from '../../../store/useScreenWidth';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import { useNavigate } from 'react-router-dom';
import { EndPoints } from '../../../utils/apiEndpoints';
import { useUserStore } from '../../../store/useUserStore';
import { StorageItems } from '../../../utils/storageItems';
import { darkModeBackgroud } from '../../../utils/constants';
import { useLanguageStore } from '../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../store/useDarkModeStore';

interface UserItems {
    id: number;
    items: { name: string, icon: JSX.Element, handleClickItem?: () => void; }[];
}

const iconStyle = { width: '20px', height: '20px' };

const UserBtn = () => {
    const navigate = useNavigate();
    const isSmallScreen = useScreenWidth();
    const { user } = useUserStore();
    const { setUser } = useUserStore();
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const { TOKEN, REFRESHTOKEN, } = StorageItems;
    const { LOGIN, FAQ, PROFILE } = EndPoints;

    const handleLogOut = () => {
        setUser(null);
        Cookies.remove(TOKEN);
        Cookies.remove(REFRESHTOKEN);
        navigate(LOGIN);
    }

    const handleFaq = () => {
        navigate(FAQ);
        setAnchorEl(null);
    }

    const handleProfile = () => {
        navigate(PROFILE);
        setAnchorEl(null);
    }

    const records: UserItems[] = [
        {
            id: 1,
            items: [
                { name: 'Profile', icon: <PersonOutlineOutlinedIcon sx={iconStyle} />, handleClickItem: handleProfile },
            ]
        },
        {
            id: 2,
            items: [
                { name: 'FAQ', icon: <HelpOutlineRoundedIcon sx={iconStyle} />, handleClickItem: handleFaq },
            ]
        },
        {
            id: 3,
            items: [{ name: 'SignOut', icon: <PowerSettingsNewRoundedIcon sx={iconStyle} />, handleClickItem: handleLogOut }]
        },
    ]

    const open = Boolean(anchorEl);
    const id = open ? 'user-btn-popover' : undefined;

    return (
        <React.Fragment>
            <Button
                variant="text"
                onClick={handleClick}
                className="button-hover-circle"
                style={{ background: 'rgba(50, 71, 92, 0.04)', borderRadius: '50%' }}
            >
                <PermIdentityOutlinedIcon
                    className='icon-sidebar-top-color'
                    sx={{ width: '22px', height: '22px', color: darkMode ? 'white' : '#4D5F71' }}
                />
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                sx={{
                    '& .MuiPopover-paper': {
                        marginTop: '8px',
                        marginLeft: isSmallScreen ? '-50px' : '-100px',
                    },
                }}
            >
                <div
                    className='d-flex flex-column'
                    style={{ width: '230px', background: darkMode ? darkModeBackgroud : 'white' }}
                >
                    <div className='d-flex flex-row gap-3 border-bottom p-3 pb-2'>
                        <Avatar sx={{ background: '#E7E7FF', color: '#696CFF' }}>{user ? user.fullname.charAt(0) : ''}</Avatar>
                        <div className='d-flex flex-column'>
                            <span
                                style={{ fontSize: '16px', color: darkMode ? 'white' : 'rgba(50, 71, 92, 0.87)', fontWeight: 600, opacity: .85 }}
                            >
                                {user?.fullname}
                            </span>
                            <span
                                style={{ fontSize: '14px', color: darkMode ? 'white' : 'rgba(50, 71, 92, 0.6)' }}
                            >
                                {user?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']}
                            </span>
                        </div>
                    </div>
                    {
                        records?.map(record =>
                            <div key={record.id} className='d-flex flex-column '>
                                {
                                    record.items?.map(i =>
                                        <span
                                            role='button'
                                            key={i.name}
                                            onClick={i.handleClickItem}
                                            className={`user-top-bar-item ${darkMode && 'text-white'}`}
                                        >
                                            {i.icon} {language[i.name]}
                                        </span>
                                    )}
                            </div>
                        )
                    }
                </div>
            </Popover >
        </React.Fragment >
    );
};

export default UserBtn;
